
  <app-loader [style.display]="isAuthenticated ? 'inline' : 'none'"></app-loader>
  <app-navbar [style.display]="isAuthenticated ? 'inline' : 'none'"></app-navbar>
  <mat-drawer-container style="height:95%;min-height:630px;">
    <mat-drawer #drawer class="example-sidenav" mode="side" position="end" opened="{{helpopened}}">
      <app-content></app-content>
    </mat-drawer>
    
    <div style="height:85vh;">
      <div *ngIf="cornerribbontext!=='Produktion'" class="corner-ribbon bottom-right sticky {{cornerribboncolor}} shadow">{{cornerribbontext}}</div>
      <router-outlet>
      </router-outlet>
    </div>
  </mat-drawer-container>
  <p-toast [life]="5000"></p-toast>
  <p-confirmDialog></p-confirmDialog>
 
  <router-outlet name="sidemenu" style="background-color:lightgoldenrodyellow;"></router-outlet>
